import React from 'react';
import { X } from 'lucide-react';
import JobSeekerForm from './JobSeekerForm';
import type { JobSeekerProfile, JobSeekerProfileData } from '../../../types/profiles';

interface EditProfileModalProps {
  profile: JobSeekerProfile;
  onClose: () => void;
  onSubmit: (data: JobSeekerProfileData) => Promise<void>;
}

export default function EditProfileModal({ profile, onClose, onSubmit }: EditProfileModalProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-2xl w-full p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <X className="h-6 w-6" />
        </button>

        <h2 className="text-2xl font-semibold mb-6">Edit Profile</h2>

        <JobSeekerForm
          initialData={profile}
          onSubmit={async (data) => {
            await onSubmit(data);
            onClose();
          }}
          onCancel={onClose}
        />
      </div>
    </div>
  );
}